import React, {Component} from "react";
import styles from "./AccountTable.module.css";
import classNames from "classnames";
import {withApplicationContext} from "../../../contexts/ApplicationContext";
import TableCol from "./TableCol";
import { numberWithCommas } from "../../../helpers/helpers";
class TableColAmount extends Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { value, yellow, red, green, className, onClick } = this.props
        return (
            <TableCol classes={styles.NoPadding}>
                <div className={styles.AmountCol}>
                    <div class={classNames(styles.AmountColSign, yellow && "yellow-text", red && "red-text", green && "green-text")}>USD</div>
                    <div onClick={onClick??null} class={classNames(styles.AmountColPrice, yellow && "yellow-text", red && "red-text", green && "green-text", className, onClick && "underline-link")}>
                        {value && numberWithCommas(value)}
                    </div>
                </div>
            </TableCol>
        );
    }
}
export default withApplicationContext(TableColAmount);